module.exports = __webpack_public_path__ + "static/media/background1.59bc33c8.jpg";